// extracted by mini-css-extract-plugin
module.exports = {"button":"skins-smallOnConfined-button-b19afa82","buttonLoading":"skins-smallOnConfined-buttonLoading-1a283f9b"};